import React, { useState, useEffect } from "react";

import {
  Button,
  Chip,
  colors,
  Container,
  Grid,
  Hidden,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import useFetchURL from "../../../../components/Hooks/useFetchURL";
import { uri } from "../../../../help/Api";
import TotalCard from "../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
  useStylesHed,
  useStylesSpDial,
  useStylesUiElemment,
} from "../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
// import { SearchActivityReports } from "../../../../../services/accMasn-services";
import moment from "moment";
import axios from "axios";
import { sto } from "../../../../Context/InshData";
import DailyJenralForms from "./DailyJenralForms";
import DailyJenralTable from "./DailyJenralTable";
const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },
  itemW: {
    // display:'flex',
    width: "90%",
  },
  headerTitle: {
    backgroundColor:"#d3d3d3",
    textAlign: "center",
    fontSize: 20,
    width: "100%",
  },

  allWidth: {
    minWidth: 650,
  },
  checStyl: {
    marginTop: "17px",
    fontSize: "16px",
    padding: "-1px",
  },
  accountCard: {
    backgroundColor: "#d3d3d3",
    borderColor: "#808080",
  },
}));

export default function DailyJenral(props) {
  const { AutoOptions } = props;
  const { t } = useTranslation(["forms", "translation"]);

   const docTypes = [
    { id: -1, name: t("forms:all") },
    { id: 1, name: t("forms:purchase-invoice") },
    { id: 2, name: t("forms:sale-invoice") },
    { id: 3, name: t("forms:purchase-return-invoice") },
    { id: 4, name: t("forms:sale-return-invoice") },
    { id: 5, name: t("forms:external-receipt-voucher") },
    { id: 6, name: t("forms:external-exchange-voucher") },
    { id: 7, name: t("forms:internal-receipt-voucher") },
    { id: 8, name: t("forms:internal-exchange-voucher") },
    { id: 9, name: t("forms:opening-stock") },
    { id: 10, name: t("forms:daily-restriction") },
    { id: 11, name: t("forms:opening-restriction") },
    { id: 12, name: t("forms:sales-switch") },
  ];
  
  const resSubType = [
    { id: -1, name: t("forms:do-not-exclude-cash-transactions") },
    { id: 1, name: t("forms:exclude-cash-transactions") },
  ];
  
  const SearchDialyJenral = {
    dateFrom: moment(new Date()).format('YYYY-MM-DD'),
    timeFrom: moment(new Date()).format('HH:mm'),
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    timeTo: moment(new Date()).format('HH:mm'),
    type: docTypes[0],
    branch: { id: -1, name: t("forms:all") },
    res_id:'',
    book_id:'',
    doc_id:'',
    doc_id2:'',
    resSub:resSubType[1],
  };

  const [rptParams, setRptParams] = React.useState(SearchDialyJenral);
  const classes = useStyles();
  const clasui = useStylesUiElemment();
  const clasSp = useStylesSpDial();
  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [sum, setSum] = useState(false);
  const viewHandle = async () => {

    setData([]);
    setFetching(true);
    await axios
      .get(
        uri +
        `AccountReports/dialyJenral?res_id=${rptParams?.res_id}
        &&type=${rptParams.type?.id}
        &&doc_id=${rptParams?.doc_id}
        &&doc_id2=${rptParams?.doc_id2}
        &&book_id=${rptParams.book_id}
        &&branch=${rptParams?.branch?.id}
        &&dateFrom=${rptParams.dateFrom + ' ' + rptParams.timeFrom}
        &&dateTo=${rptParams.dateTo + ' ' + rptParams.timeTo}
       &&res_sub=${rptParams?.resSub?.id}`
      )
      .then((res) => {
        setData(res.data);
        console.log(" the data is", res.data);
        setFetching(false);
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
        // toast.err(t("fetch-error"));
        setData([]);
      });
  };

  const his = useHistory();
  const printHandle = () => {
      
    if (data.length == 0) {
      alert(t("forms:no-data"));
    } else {
      const info = {
        data: data?.dailyData,
        tot: data?.totals,
        from: t("forms:business-activity"),
        title: t("forms:general-journal-report"),
        tot1:0,
        tot2:1 ,
        tot3:1,
        fDate:rptParams?.dateFrom,
        tDate: rptParams?.dateTo,
        nDate: moment(new Date()).format("YYYY-MM-DD"),
        branch: rptParams.branch?.name,
      };
      localStorage.setItem("iInfos", JSON.stringify(info));
      his.push({ pathname: "/ReviewActivity" });
      window.location.reload(true);
    }
  };

  let excel_name = t("forms:general-journal-report");
  const excelHeaders = [
    { label: t("forms:restriction-no"), key: "doc_no" },
    { label: t("forms:account-code"), key: "acc_no" },
    { label: t("forms:account-name"), key: "NameAcount" },
    { label: t("forms:currency"), key: "symbol" },
    { label: t("forms:note"), key: "notes" },
    { label: t("forms:dept"), key: "dept" },
    { label: t("forms:credit"), key: "credit" },
    { label: t("forms:cost-center"), key: "Namecostcenter" },
  ];

  const onChangeData = (propName) => (event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
  };
  const onChangeAutoData = (propName, newValue) => {
    setRptParams({ ...rptParams, [propName]: newValue });
  };
  return (
    <div className={classes.root}>
      <Grid container item xs={12}>
        <Typography
          size="small"
          className={classes.headerTitle}
          color="primary"
        >
          {t("forms:general-journal-report")}
        </Typography>
      </Grid>
      <Typography
        component="div"
        style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
      >
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            paddingBottom: "0px",
            borderBottomColor: "#d3d3d3",
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
          }}
        >
          <DailyJenralForms
            {...{
                rptParams,
                onChangeData,
                onChangeAutoData,
              AutoOptions,
              docTypes,
              resSubType
            }}
          />
          <Grid
            container
            justifyContent="center"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            spacing={1}
          >
            <Hidden smUp={["sm"]}>
              <Grid item>
                <Button
                  disabled={fetching}
                  variant="contained"
                  startIcon={<ScannerIcon />}
                  size="large"
                  style={
                    (inshst.sal.iconBtnAcc,
                        { borderRadius: 0 })
                }
                className={[clasui.buttonAcc]}
                  onClick={() => viewHandle()}
                >
                  {t("forms:show")}
                </Button>
              </Grid>
            </Hidden>
            <Hidden only={["xs"]}>
              <Grid item>
                <Button
                  disabled={fetching}
                  variant="contained"
                  startIcon={<ScannerIcon />}
                  size="large"
                  style={
                    (inshst.sal.iconBtnAcc,
                        { borderRadius: 0 })
                }
                className={[clasui.buttonAcc]}
                  onClick={() => viewHandle()}
                >
                  {t("forms:view")}
                </Button>
              </Grid>
            </Hidden>

            <Hidden smUp={["sm"]}>
              <Grid item >
                {data && !fetching && data.dailyData && (
                  <CSVLink
                    separator={";"}
                    filename={excel_name}
                    data={data.dailyData}
                    headers={excelHeaders}
                  >
                    {" "}
                    <Button
                      disabled={fetching}
                      variant="contained"
                      startIcon={<TableChart />}
                      size="large"
                      color="primary"
                      style={{ borderRadius: 0 }}
                      className={[clasui.buttonAcc]}
                    >
                      {t("forms:excel")}
                    </Button>
                  </CSVLink>
                )}
              </Grid>
            </Hidden>
            <Hidden only={["xs"]}>
              <Grid item >
                {data && !fetching && data.dailyData && (
                  <CSVLink
                    separator={";"}
                    filename={excel_name}
                    data={data.dailyData}
                    headers={excelHeaders}
                  >
                    {" "}
                    <Button
                      disabled={fetching}
                      variant="contained"
                      startIcon={<TableChart />}
                      size="large"
                      color="primary"
                      style={{ borderRadius: 0 }}
                      className={[clasui.buttonAcc]}
                    >
                      {t("forms:excel_export")}{" "}
                    </Button>
                  </CSVLink>
                )}
              </Grid>
            </Hidden>
            {/* <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<PrintIcon />}
                color="primary"
                size="large"
                className={[clasui.buttonAcc]}
                style={
                  ( inshst.sal.iconBtnAcc,
                    { borderRadius: 0 })
                }
                onClick={printHandle}
              >
                {t("forms:print")}
              </Button>
            </Grid> */}
            <Grid item>
              <Button
                variant="contained"
                startIcon={<KeyboardReturnSharpIcon />}
                color="secondary"
                size="large"
                className={[clasui.button, clasSp.clcan]}
                style={
                  ( inshst.sal.iconBtnAcc,
                    { borderRadius: 0 })
                }
                onClick={() => his.goBack()}
              >
                {t("forms:exit")}
              </Button>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth={true} style={{ padding: "4px" }}>
          <Grid container spacing={1} style={{ paddingTop: "10px" }}>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className:  classes.accountCard ,
                  title: t("forms:count_row"),
                  value: data?.totals?.qtyTotal,
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                    className:  classes.accountCard ,
                    title:t("forms:total-debit"),
                  value: data?.totals?.minusTotal.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                    className:  classes.accountCard ,
                  title: t("forms:total-credit"),
                  value: data?.totals?.costTotal.toFixed(2),
                }}
              />
            </Grid>

          </Grid>
        </Container>
        {/* <br /> */}
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Grid container justifyContent="center">
            <Grid item container justifyContent="center" xs={12}>
              <BeatLoader loading={fetching} color="#808080" />
              {!fetching && (
                <DailyJenralTable
                  {...{
                    data: data?.dailyData ? data.dailyData : [],
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Container>
      </Typography>
    </div>
  );
}
